import { currencyValueFormatter } from '../../../../utils/formatters.ts'
import { IdeyaButton } from '../../../../common/antd/ideya-button/ideya-button.tsx'
import { ICellRendererParams, ValueFormatterParams } from 'ag-grid-enterprise'

interface IdeaTotalPnlCellProps extends ICellRendererParams {
  onButtonClick: (rowData: string) => void
}

export const IdeaTotalPnlCell: React.FC<IdeaTotalPnlCellProps> = ({
  value,
  data,
  onButtonClick,
}) => {
  const formattedValue = currencyValueFormatter(
    { value } as ValueFormatterParams,
    { decimal: 0, currency: 'USD' }
  )

  const handleClick = () => {
    onButtonClick(data)
  }

  return (
    <div style={{ alignItems: 'center' }}>
      <span>{formattedValue}</span>
      <IdeyaButton
        ghost
        size={'small'}
        onClick={handleClick}
        style={{ marginLeft: '4px' }}
      >
        ...
      </IdeyaButton>
    </div>
  )
}
